import { render, staticRenderFns } from "./EndpointPermissionsBuilder.vue?vue&type=template&id=2a430b96&scoped=true&"
import script from "./EndpointPermissionsBuilder.vue?vue&type=script&lang=js&"
export * from "./EndpointPermissionsBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a430b96",
  null
  
)

export default component.exports